import hatsApi from '@/services/hatsApi'

export default {
  getLanguages (params) {
    let filter = params || ''
    return hatsApi().get('/system/language/?filter=' + filter)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Language.js